
import { Controller, useFormContext } from "react-hook-form";
import { Input } from "antd";

export const MessageInput = () => {
    const { control } = useFormContext();

    return (
        <Controller
            name="message"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
                <>
                    <label>Type your message</label>
                    <Input.TextArea
                        {...field}
                        placeholder="Type your message"
                        rows={4}
                        status={fieldState.error ? "error" : ""}
                    />
                    {fieldState.error && <p style={{ color: "red" }}>This field is required</p>}
                </>
            )}
        />
    );
};